import React from 'react';
import {Form, Input, Row, Col, Switch, FormInstance} from 'antd';
import {HttpService} from "../../../../services/http/Http.service";
import {HttpErrorService} from "../../../../services/http/HttpError.service";

interface AddressFormProps {
    autoFillAddress: boolean,
    disableAddressFields: boolean,
    disabled?: boolean,
    form: FormInstance<any>,
    personCF: string,
    setAutoFillAddress: (value: (((prevState: boolean) => boolean) | boolean)) => void
}

export default function AddressForm({
                                        autoFillAddress,
                                        disableAddressFields,
                                        disabled,
                                        form,
                                        personCF,
                                        setAutoFillAddress
                                    }: AddressFormProps) {
    const requiredIfEditable = !autoFillAddress && !disableAddressFields;

    const handleToggle = async (checked: boolean) => {
        try {
            const data = await HttpService.getInstanceAxios().get(`/person/searchBy?userInput=${personCF}`);
            const addressInfo = data.data.content[0]
            setAutoFillAddress(checked);
            if (checked) {
                form.setFieldsValue({
                    province: addressInfo.residenceProvince,
                    city: addressInfo.residenceCity,
                    cap: addressInfo.residencePostalCode,
                    address: addressInfo.residenceAddress,
                    houseNumber: addressInfo.residenceHouseNumber,
                });
            } else {
                form.setFieldsValue({
                    province: '',
                    city: '',
                    cap: '',
                    address: '',
                    houseNumber: '',
                });
            }
        } catch (error) {
            HttpErrorService.handle("Errore durante il recupero dei dati", error, true)
        }
    };
    return (
        <>
            <Form.Item label="Vuoi usare l'indirizzo esistente?">

                <Switch checked={autoFillAddress} onChange={handleToggle} disabled={disabled}/>
            </Form.Item>

            <Row gutter={8}>
                <Col span={12}>
                    <Form.Item
                        label="Provincia"
                        name="province"
                        rules={
                            requiredIfEditable
                                ? [
                                    { required: true, message: "Inserisci la provincia!" },
                                    { len: 2, message: "La provincia deve contenere esattamente 2 caratteri!" }
                                ]
                                : [
                                    { len: 2, message: "La provincia deve contenere esattamente 2 caratteri!" }
                                ]
                        }
                    >
                        <Input disabled={disableAddressFields}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Città"
                        name="city"
                        rules={
                            requiredIfEditable
                                ? [{required: true, message: "Inserisci la città!"}]
                                : []
                        }
                    >
                        <Input disabled={disableAddressFields}/>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={8}>
                <Col span={8}>
                    <Form.Item
                        label="CAP"
                        name="cap"
                        rules={
                            requiredIfEditable
                                ? [{required: true, message: "Inserisci il CAP!"}]
                                : []
                        }
                    >
                        <Input disabled={disableAddressFields}/>
                    </Form.Item>
                </Col>
                <Col span={10}>
                    <Form.Item
                        label="Indirizzo"
                        name="address"
                        rules={
                            requiredIfEditable
                                ? [{required: true, message: "Inserisci l'indirizzo!"}]
                                : []
                        }
                    >
                        <Input disabled={disableAddressFields}/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        label="Civico"
                        name="houseNumber"
                        rules={
                            requiredIfEditable
                                ? [{required: true, message: "Inserisci il numero civico!"}]
                                : []
                        }
                    >
                        <Input disabled={disableAddressFields}/>
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
}
